import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import authService from 'services/auth.service';

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (data) => {
      const domain = window.location.origin;
      const path = 'reset-password';
      return authService.forgotPassword({ ...data, domain, path });
    },
    onSuccess: (data) => {
      toast.success(data?.message || 'Password reset link sent to your email!');
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to send reset email. Please try again.';
      toast.error(errorMessage);
    },
  });
};
